type CRMRequestType = 'educational' | 'newsletter';

interface CRMRequestValues {
  email: string;
  name?: string | null;
}
export async function doCRMRequest(
  type: CRMRequestType,
  values: CRMRequestValues,
) {
  const { email, name } = values;
  return fetch('/api/newsletter', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ type, email, name }),
  });
}
